import React, {useState, useEffect } from 'react';
import Footer from './Footer';
import { LogoTwitter, LogoFacebook, LogoYoutube } from '@carbon/react/icons';
import useUser from '@/lib/hooks/useUser';
import { useSideNavContext } from '@/contexts/SideNavContextProvider';
import { getApiVersion } from '@/redux/new_services/api';

const currentYear = new Date().getFullYear();

const Content = () => (
  <>
    <p>Wir sind für Dich da.</p>
    <p>
      zwei&40 GmbH
      <br />
      Annenheider Str. 257
      <br />
      27755 Delmenhorst
      <br />
      <br />
      Tel. 04221 99895-0
      <br />
      <a
        style={{ textDecoration: 'underline' }}
        href="mailto:info@micast.de?subject=Ich%20habe%20eine%20frage">
        info@micast.de
      </a>
    </p>
  </>
);

const LeftContent = () => {

  const [apiVersion, setApiVersion] = useState(null);

  useEffect(() => {
    // Asynchrone Funktion wird im Hintergrund aufgerufen
    const fetchApiVersion = async () => {
      try {
        getApiVersion().then((response) => {
          const data = response.data;
          console.info('API-Version:', data);
          setApiVersion(data);
        });
      } catch (error) {
        console.error('Fehler beim Abrufen der API-Version:', error);
      }
    };

    fetchApiVersion();
  }, []); // Leeres Dependency-Array, sodass der Aufruf nur einmal passiert


  const {expireDate} = useUser();
  return (
    <p>
      Dasboard Version&nbsp;
      {(process.env.REACT_APP_VERSION && process.env.REACT_APP_VERSION !== "") && process.env.REACT_APP_VERSION}&nbsp;
      {(process.env.REACT_APP_COMMIT_DATE && process.env.REACT_APP_COMMIT_DATE !== "") && process.env.REACT_APP_COMMIT_DATE}&nbsp;
      {(process.env.REACT_APP_COMMIT_URL && process.env.REACT_APP_COMMIT_URL !== "") && process.env.REACT_APP_COMMIT_URL && <a href={process.env.REACT_APP_COMMIT_URL}>{process.env.REACT_APP_COMMIT_SHA_SHORT}</a>}
      <br />
      API Version&nbsp;{apiVersion?.version && apiVersion.version}&nbsp;
      {apiVersion?.commit_date && apiVersion.commit_date}&nbsp;
      {apiVersion?.commit_url && <a href={apiVersion.commit_url}>{apiVersion?.commit_sha}</a>}
      <br />
      Copyright © {currentYear} zwei&40 GmbH
      <br />
      {expireDate}
    </p>
  )
};

const links = {
  firstCol: [
    { href: 'https://micast.de/impressum', linkText: 'Impressum' },
    { href: 'https://micast.de/datenschutz', linkText: 'Datenschutz' },
    { href: 'https://www.zweiund40.com/', linkText: 'zweiund40.com' },
  ],
  secondCol: [
    {
      href: 'https://twitter.com/micastde',
      linkText: <LogoTwitter size={32} />,
    },
    {
      href: 'https://facebook.com/micastde',
      linkText: <LogoFacebook size={32} />,
    },
    {
      href: 'https://www.youtube.com/channel/UCYTIhPS6lyKc5Vq02zz7t7g',
      linkText: <LogoYoutube size={32} />,
    },
  ],
};

const CustomFooter = () => {
  const {visible, maximized} = useSideNavContext();

  return (
    <Footer links={links} Content={Content} LeftContent={LeftContent} showSideNav={visible} minimizedSideNav={!maximized} />
  );
}

export default CustomFooter;
